import styled from 'styled-components/macro';
import { Image } from '@yme/atoms/image';
import { colorWhiteTransparent200, socialIconBackgroundColor } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export const SocialIconWrapperStyled = styled(FlexWrapper) `
  background-color: ${colorWhiteTransparent200};

  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: all 0.25s;

  &:hover {
    background-color: ${socialIconBackgroundColor};
  }
`;
export const ImageStyled = styled(Image) `
  height: 16px;

  transition: all 0.25s;
`;
